import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SessionQuery } from 'src/app/core/state/session/session.query';
import { ImpersonateQuery } from '../../state/impersonate.query';
import { pluck } from 'rxjs/operators';
import { RouterLink } from '@angular/router';
import { IconsModule } from '../../../../../shared/icons/icons.module';
import { ImpersonateService } from '../../state/impersonate.service';
import { fadeInOut } from '../../../../../shared/animations/fade-in-out.animation';

@Component({
    selector: 'sb-impersonation-notice',
    standalone: true,
    imports: [CommonModule, RouterLink, IconsModule],
    templateUrl: './sb-impersonation-notice.component.html',
    styleUrls: ['./sb-impersonation-notice.component.scss'],
    animations: [fadeInOut]
})
export class SbImpersonationNoticeComponent {
    constructor(
        private sessionQuery: SessionQuery,
        private impersonateQuery: ImpersonateQuery,
        private impersonateService: ImpersonateService
    ) {}

    userFullName$ = this.sessionQuery.userFullName$;
    impersonatedUserName$ = this.impersonateQuery.userName$;

    endImpersonation(event: MouseEvent) {
        event.preventDefault();
        this.impersonateService.endImpersonation();
    }
}
